import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  // MODAL
  inactiveRefundInformativePageTitle: (
    <PortalMessage id='t.app.personalData.inactiveRefundInformativePage.title' defaultMessage='Storno non attivo sui punti vendita Intesa Sanpaolo' />
  ),
  inactiveRefundInformativePageText: (
    <PortalMessage id='t.app.personalData.inactiveRefundInformativePage.text' defaultMessage='<strong>Contatta la Filiale Digitale di Intesa Sanpaolo</strong> al <strong>800 303 303</strong> dall’Italia (oppure +39 011 8019 200 dall’estero) per verificare la tua posizione. <br/><br/> Se scegli di proseguire, potrai inserire il tuo Codice Fiscale, ma <strong> non sarai abilitato a stornare sui punti vendita Intesa Sanpaolo.</strong>' />
  ),
  proceed: (
    <PortalMessage id='t.app.proceed' defaultMessage='Prosegui' />
  ),
  close: (
    <PortalMessage id='t.app.close' defaultMessage='Chiudi' />
  )
}

export default formattedMessage
